const BlocSlider = (target) => {
  const initSlider = $el => {
    $el.slick($el.data('slider-params'));
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      initSlider($el);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el)
        }
      });
    });
}

export default BlocSlider;



// WEBPACK FOOTER //
// ./scripts/components/BlocSlider.js